import { App, Button, Input } from 'antd';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';

interface ArrayInputProps {
  id: string;
  max?: number;
  value?: string[];
  onChange: (val: string[]) => void;
}
const ArrayInput = ({ id, value, max = 100, onChange }: ArrayInputProps) => {
  const { notification } = App.useApp();
  const { t } = useTranslation('common');
  const [array, setArray] = useState<string[]>([]);

  useEffect(() => {
    if (value && Array.isArray(value)) {
      setArray(value);
    } else {
      setArray(['']);
    }
  }, [value]);

  return (
    <div className="space-y-5 w-full">
      {array.map((v, index) => {
        return (
          <Input
            value={v}
            prefix={`${index + 1}. `}
            placeholder={t('enter_value', { index: index + 1 })}
            onChange={(e) => {
              const newArray = [...array].filter((a) => a !== '');
              newArray[index] = e.target.value;
              setArray(newArray);
              onChange(newArray);
            }}
            data-test={`${id}-input-${index}`}
          />
        );
      })}
      <Button
        block
        onClick={() => {
          if (array.length >= max) {
            notification.error({
              message: t('max_items', { max }),
            });
            return;
          }
          setArray([...array, '']);
        }}
        data-test={`${id}-add-btn`}
      >
        {t('add')}
      </Button>
    </div>
  );
};

export default ArrayInput;
